// extracted by mini-css-extract-plugin
export var dropdownIndicator = "Dropdown_dropdownIndicator__5LEj1";